module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<hr/>\n<table>\n	<tr>\n		<th>Subnet Scan</th>\n		<td><input type=\'text\' class=\'field\' placeholder=\'x.x.x.0\' id=\'options.netscan\' value=\''+
((__t=(options.netscan))==null?'':__t)+
'\'></td>\n	</tr>\n</table>\n';
}
return __p;
};
